import { FC, MouseEvent } from 'react';
import { CaretDown, Info } from 'phosphor-react';
import { Button } from '../../Common/Button';

interface HelpButtonProps {
  text: string;
  onClick: (e?: MouseEvent) => void;
}

export const HelpButton: FC<HelpButtonProps> = ({ text, onClick }) => {
  return (
    <>
      <div className="hidden pr-20 md:block">
        <Button
          size="large"
          text={text}
          textColor="text-text-dark"
          rightIcon={<CaretDown className="text-text-dark" size={22} />}
          onClick={onClick}
          hover
        />
      </div>

      <div className="flex flex-row items-center md:hidden">
        <button onClick={onClick} className="p-3 rounded-full bg-text-gray">
          <Info size={24} className="text-white" />
        </button>
      </div>
    </>
  );
};
